module.exports = __webpack_public_path__ + "about-us-b998e096/encoding-c671d723d48853ff8aba29a41d9c1ba6.svg";